<div class="card">
    <p class="title">
        {{props?.evaluatedCalculationFunction?.(field)?.title || props.title}}
    </p>
    <p class="current-period-label">
        {{props?.evaluatedCalculationFunction?.(field)?.currentPeriodName || props.currentPeriodName}}
    </p>
    <div class="d-flex align-items-center gap-3">
        <div class="empty-bar">
            <div class="filled-bar" [style.width.%]="props?.evaluatedCalculationFunction?.(field)?.percentageValue || props.percentageValue"></div>
        </div>
        <p class="mb-0">
            <strong>{{props?.evaluatedCalculationFunction?.(field)?.totalPeriodName || props.totalPeriodName}}</strong>
        </p>
    </div>
</div>

